import { TextField } from '@mui/material';

interface ScopeFieldProps {
  value: string;
  setValue: (value: string) => void;
}

function ScopeField({ value, setValue }: ScopeFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Scope'
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default ScopeField;

